<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示：</div>
      <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
      <div class="no">
        2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
      </div>
      <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
      <div class="no">
        4.智绘网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </div>
    </div>
    <div>
      <navStepList
        style="justify-content: center; margin: 40px 0"
        :value="navStepList"
        :current="navStepCurrent"
        :lineWidth="40"
      ></navStepList>
    </div>
    <div class="tips-section" v-if="detail.title || $route.query.id">
      <div class="d-table">
        <div class="d-item">
          <div class="d-item-name d-item-row">
            <div class="d-item-row-name">发票金额：</div>
            <div>¥ {{ detail.invoiceAmount }}</div>
          </div>
          <div class="d-item-value">
            <div class="d-item-name d-item-row" style="border-right: none">
              <div class="d-item-row-name">发票抬头：</div>
              <div>{{ detail.title }}</div>
            </div>
          </div>
        </div>
        <div class="d-item">
          <div class="d-item-name d-item-row">
            <div class="d-item-row-name">发票状态：</div>
            <div>{{ detail.invoiceStatus | invoiceStatus }}</div>
          </div>
          <div class="d-item-value">
            <div class="d-item-name d-item-row" style="border-right: none">
              <div class="d-item-row-name">发票编号：</div>
              <div>{{ detail.invoiceNo }}</div>
            </div>
          </div>
        </div>
        <div class="d-item">
          <div class="d-item-name d-item-row">
            <div class="d-item-row-name">发票类型：</div>
            <div>{{ detail.invoiceType }}</div>
          </div>
          <div class="d-item-value">
            <div class="d-item-name d-item-row" style="border-right: none">
              <div class="d-item-row-name">申请时间：</div>
              <div>{{ detail.createdAt }}</div>
            </div>
          </div>
        </div>
        <div class="d-item">
          <div class="d-item-name d-item-row">
            <div class="d-item-row-name">收件人：</div>
            <div>{{ detail.recipient }}</div>
          </div>
          <div class="d-item-value">
            <div class="d-item-name d-item-row" style="border-right: none">
              <div class="d-item-row-name">收货地址：</div>
              <div>{{ detail.address }}</div>
            </div>
          </div>
        </div>
        <div class="d-item">
          <div class="d-item-name d-item-row">
            <div class="d-item-row-name">邮编：</div>
            <div>{{ detail.postcode }}</div>
          </div>
          <div class="d-item-value">
            <div class="d-item-name d-item-row" style="border-right: none">
              <div class="d-item-row-name">联系电话：</div>
              <div>{{ detail.mobile }}</div>
            </div>
          </div>
        </div>
        <div class="d-item">
          <div class="d-item-name d-item-row">
            <div class="d-item-row-name">物流公司：</div>
            <div>{{ detail.expressCompany }}</div>
          </div>
          <div class="d-item-value">
            <div class="d-item-name d-item-row" style="border-right: none">
              <div class="d-item-row-name">快递单号：</div>
              <div>{{ detail.expressNo }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="nodata">发票不存在！</div>
    <div class="table-data" v-if="$route.query.id">
      <div class="total">关联交易（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="remark" slot-scope="{ row }">
          <Button @click="onShowRemark(row.remark)">查看备注</Button>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
  </div>
</template>

<script>
import navStepList from "components/navStepList";
import { invoiceInvoiceDetail } from "api/customer.js";
import pushRemarkModal from "components/push/pushRemarkModal.vue";
export default {
  name: "invoiceInfo",
  components: {
    navStepList,
    pushRemarkModal,
  },
  filters: {
    invoiceStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未处理";
          break;
        case 1:
          title = "待审核";
          break;
        case 2:
          title = "待开票";
          break;
        case 3:
          title = "已开票";
          break;
        case 4:
          title = "待寄出";
          break;
        case 5:
          title = "已寄出";
          break;
        case 6:
          title = "审核未通过";
          break;
        case 7:
          title = "用户取消";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      navStepList: [
        "选择开票订单",
        "填写发票信息和地址",
        "后台审核，邮寄发票",
        "签收快递，开票成功",
      ],
      navStepCurrent: 0,
      detail: {
        title: "",
        address: "",
        contentType: 0,
        createdAt: "",
        expressCompany: "",
        expressNo: "",
        expressPaymentType: 0,
        invoiceAmount: 0,
        invoiceNo: "",
        invoiceStatus: 0,
        invoiceType: 0,
        issueType: 0,
        mobile: "",
        postcode: "",
        recipient: "",
        remark: "",
      },
      columns: [
        {
          title: "交易时间",
          key: "createdTime",
          align: "center",
        },
        {
          title: "类型",
          key: "typeName",
          align: "center",
        },
        {
          title: "交易金额",
          key: "payable",
          align: "center",
        },
        {
          title: "可开票金额",
          key: "availableAmount",
          align: "center",
        },
        {
          title: "备注",
          ellipsis: true,
          slot: "remark",
          align: "center",
        },
      ],
      data: [],
      limit: 10,
      page: 1,
      total: 0,
      tableLoading: false,
      pushRemarkModalVisibility: false,
      remark: "", // 备注内容
    };
  },
  created() {
    this.req_invoiceInvoiceDetail();
  },
  methods: {
    async req_invoiceInvoiceDetail() {
      try {
        let params = {
          invoiceId: this.$route.query.id,
          limit: this.limit,
          page: this.page,
        };
        const { code, data } = await invoiceInvoiceDetail(params);
        if (code === 200 && data) {
          if (!this.detail.title) {
            this.detail.title = data.title;
            this.detail.address = data.address;
            this.detail.contentType = data.contentType;
            this.detail.createdAt = data.createdAt;
            this.detail.expressCompany = data.expressCompany;
            this.detail.expressNo = data.expressNo;
            this.detail.expressPaymentType = data.expressPaymentType;
            this.detail.invoiceAmount = data.invoiceAmount;
            this.detail.invoiceNo = data.invoiceNo;
            this.detail.invoiceStatus = data.invoiceStatus;
            this.detail.invoiceType = data.invoiceType;
            this.detail.issueType = data.issueType;
            this.detail.mobile = data.mobile;
            this.detail.postcode = data.postcode;
            this.detail.recipient = data.recipient;
            this.detail.remark = data.remark;
          }
          this.data = data.moreInfo.list;
          this.total = data.moreInfo.total;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_invoiceInvoiceDetail();
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
  },
};
</script>

<style lang="less" scoped>
.tips-section {
  padding: 30px 50px 30px;
  background-color: #fff;
  border-radius: 8px;
  .title {
    color: #333333;
    font-size: 14px;
    font-weight: Bold;
    line-height: 36px;
  }
  .no {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
  }
}
.d-item-row {
  display: flex;
  align-items: center;
  .d-item-row-name {
    width: 100px;
  }
}
.d-table {
  width: 100%;
  background-color: #fff;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;
  .d-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
  }
  .d-item-name {
    width: 320px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-weight: bold;
    color: #333333;
    border-right: 1px solid #e8e8e8;
  }
  .d-item-name.required {
    &::before {
      content: "*";
      margin-right: 10px;
      color: #ff5c35;
    }
  }
  .d-item-value {
    display: flex;
    align-items: center;
    margin-left: 60px;
  }
}
.nodata {
  min-height: 200px;
  line-height: 200px;
  background-color: #fff;
  text-align: center;
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>
